module.exports = __webpack_public_path__ + "static/img/no_search.210e37d9.png";